import { getMonth as o } from "date-fns";
const s = (t, r) => {
  if (!t) return !1;
  const n = o(t);
  return r === n;
};
export {
  s as isCurrentMonth
};
